import { StandardDialog } from '@roc/ui';
import { useDocumentStore } from '@roc/feature-documents';
import { Document } from '@roc/feature-types';
import { AppraisalOrderDetails } from './appraisalOrderDetails';
import { useStore } from '@roc/client-portal-shared/hooks';
import { useEffect } from 'react';
import { CustomTaskDialog, TaskStatus } from '@roc/feature-general-tasks';
import { Grid } from '@material-ui/core';

export type AppraisalOrderDetailsDialogProps = {
  open?: boolean;
  onClose?: () => void;
  loan: any;
  document: Document;
};

export const AppraisalOrderDetailsWithARRDialog = (
  props: AppraisalOrderDetailsDialogProps
) => {
  const { open, onClose, loan, document } = props;
  const taskId = document?.taskId;
  const { globalStore } = useStore();
  const { documentStore } = useDocumentStore();
  const { documentFormStore } = documentStore;
  const { cdaAndAppraisalOrderDetailsStore } = documentFormStore;

  useEffect(() => {
    cdaAndAppraisalOrderDetailsStore.setIsInternal(
      globalStore.isInternalPortal
    );
  }, []);

  const onClick = () => {
    document.status = TaskStatus.ACCEPTED;
    cdaAndAppraisalOrderDetailsStore.acceptDocument(document);
  };

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Appraisal Order Details"
          handleClose={onClose}
          dialogContent={
            <Grid container>
              <Grid item xs={12}>
                <AppraisalOrderDetails
                  loan={loan}
                  document={document}
                  onSubmitLoanPayments={onClose}
                  onClick={onClick}
                  isTamariskLender={globalStore.userFeatures.tamariskAppraisal}
                  isInternal={globalStore.isInternalPortal}
                  noTabClassname={true}
                />
              </Grid>
            </Grid>
          }
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Appraisal Order Details"
          maxWidth="md"
          handleClose={onClose}
          dialogContent={
            <AppraisalOrderDetails
              loan={loan}
              document={document}
              onSubmitLoanPayments={onClose}
              onClick={onClick}
              isTamariskLender={globalStore.userFeatures.tamariskAppraisal}
              isInternal={globalStore.isInternalPortal}
            />
          }
        />
      )}
    </>
  );
};
